import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				padding: "0px 16px",
				overflowY: "scroll"
			},
			title: {
				fontSize: 16,
				marginTop: 7,
				color: theme.palette.primary.contrastText,
				fontWeight: 500
			},
			centerPage: {
				position: "absolute",
				left: "50%",
				top: "50%",
				transform: "translate(-50%, -50%)"
			}
		}),
	{
		name: "MerchandisingDetail",
		index: 1
	}
);

export default useStyles;
